import {
  ArrowRight, Check, ChevronDown, Menu, X, Instagram, Mail, MapPin, Clock,
  MessageCircle, Music2, Dumbbell, Target, Users, CalendarCheck, TrendingUp,
  UserPlus, Shield, Lock, Zap, Phone, type LucideIcon,
} from "lucide-react";

export const ICON_MAP: Record<string, LucideIcon> = {
  arrowRight: ArrowRight, check: Check, chevronDown: ChevronDown, menu: Menu, x: X,
  instagram: Instagram, mail: Mail, mapPin: MapPin, clock: Clock,
  messageCircle: MessageCircle, music2: Music2, dumbbell: Dumbbell, target: Target,
  users: Users, calendarCheck: CalendarCheck, trendingUp: TrendingUp,
  userPlus: UserPlus, shield: Shield, lock: Lock, zap: Zap, phone: Phone,
};

/** Renderiza un ícono a partir de su nombre guardado en el contenido editable. */
export function DynamicIcon({ name, size = 18, className }: { name: string; size?: number; className?: string }) {
  const Cmp = ICON_MAP[name] || Target;
  return <Cmp size={size} className={className} />;
}
